var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5000 5000",
    style: {
      enableBackground: "new 0 0 5000 5000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#1B1F23;} .st1{fill:#FFFFFF;} ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 5000,
    height: 5000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2500,
    cy: 2495.9,
    r: 1675.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2500,789c-943.8,0-1708.2,764.4-1708.2,1708.2c0,755.9,489,1394.3,1168,1620.7 c85.4,14.9,117.4-36.3,117.4-81.1c0-40.6-2.1-175.1-2.1-318.2c-429.2,79-540.2-104.6-574.4-200.7 c-19.2-49.1-102.5-200.7-175.1-241.3c-59.8-32-145.2-111-2.1-113.2c134.5-2.1,230.6,123.8,262.6,175.1 c153.7,258.4,399.3,185.8,497.5,140.9c14.9-111,59.8-185.8,108.9-228.5c-380.1-42.7-777.2-190-777.2-843.4 c0-185.8,66.2-339.5,175.1-459.1c-17.1-42.7-76.9-217.8,17.1-452.7c0,0,143.1-44.8,469.8,175.1c136.7-38.4,281.9-57.7,427.1-57.7 s290.4,19.2,427.1,57.7c326.7-222.1,469.8-175.1,469.8-175.1c94,234.9,34.2,410,17.1,452.7c108.9,119.6,175.1,271.2,175.1,459.1 c0,655.5-399.3,800.7-779.4,843.4c61.9,53.4,115.3,155.9,115.3,316c0,228.5-2.1,412.1-2.1,469.8c0,44.8,32,98.2,117.4,81.1 c674.7-226.3,1163.7-866.9,1163.7-1620.7C4208.2,1553.4,3443.8,789,2500,789z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon4);
export default __webpack_public_path__ + "static/media/nav-icon4.d1722596c9afb8dbe28efef796bdc9f7.svg";
export { ForwardRef as ReactComponent };